/** Environment URLs and demo fixtures shared across embed demos. */

/** Registrable domain for `or` / `or_expire` session cookies and embed `cookieDomain` / `orCookieDomain`. */
export const COOKIE_DOMAIN = '1re.click';
export const COOKIE_PREFIX = 'or';

/** Cookie `Domain` attribute as shown in UI copy (leading dot). */
export const COOKIE_SCOPE = `.${COOKIE_DOMAIN}`;

export const HITL_ORIGIN = 'https://hitl.qa.1re.click';

export const SDK_API_ORIGIN = 'https://sdkapi.qa.1re.click';

export const TOKEN_VALIDATION_URL = `${SDK_API_ORIGIN}/auth/token`;

/** Revoke session token (OneReach SPG staging). */
export const OR_LOGOUT_URL = `${SDK_API_ORIGIN}/auth/token`;

/** POST `{ token: JWT }` — response `{ payload, ttl }` becomes session cookies named from `COOKIE_PREFIX`. */
export const SHEPHERD_VET_AUTH_EXCHANGE_URL =
  `${SDK_API_ORIGIN}/http/1d9e047b-12f1-468e-af39-a8fcf66f0a1b/auth/1re-click`;

/** Mock CRM contacts used by Micro and full-embed demos. */
export const MOCK_CONTACTS = [
  {
    id: '24000c20-e970-4f50-9cb5-0fe9b0cd0bbf',
    name: 'Thomas Turner',
    phone: '+17202392661',
  },
  {
    id: '052f21e5-bb97-46dc-813d-5e4e1758260d',
    name: 'Wade Matthews',
    phone: '+17202392661',
  },
  {
    id: '8d55d54c-889a-4420-8a7f-857cca30ea85',
    name: 'Jose Rivas',
    phone: '+385977449935',
  },
];
